import React from 'react';
import { RouteComponentProps } from 'react-router';

import { RatingListContainer } from '../../epic/rating-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <RatingListContainer />;
};
